import { LoaderCircle } from 'lucide-react';

interface HeatmapLoadingStateProps {
  message: string;
}

export function HeatmapLoadingState({ message }: HeatmapLoadingStateProps) {
  return (
    <div
      role="status"
      aria-label={message}
      className="flex flex-1 flex-col items-center justify-center gap-2 px-4 text-center"
    >
      <LoaderCircle aria-hidden="true" className="h-4 w-4 animate-spin text-neutral-500" />
      <span className="font-mono text-[11px] text-neutral-500">{message}</span>
    </div>
  );
}
